export default "__VITE_ASSET__ByEeuJOu__"